import { createApp } from 'vue';
import Antd from 'ant-design-vue';
import App from './App';
import 'ant-design-vue/dist/antd.css';
import router from './router'
import i18n from './i18n'

window.document.title  = i18n.global.t("title")
const app = createApp(App).use(i18n);

app.use(Antd).use(router).mount('#app');